// @flow
import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import Button from '@material-ui/core/Button/Button';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    height: 36,
    color: theme.palette.secondary.main,
    borderRadius: 18,
  },

  textButton: {
  },
  conButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.greyScale[7],
    boxShadow: `0 4px 4px -2px ${theme.applyOpacityToHex(theme.palette.secondary.dark, .4)}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: `0 8px 8px -2px ${theme.applyOpacityToHex(theme.palette.secondary.dark, .2)}`,
    },
  },
  outButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      backgroundColor: theme.applyOpacityToHex(theme.palette.secondary.dark, 0.16),
    },
  },
  disableOut: {
    opacity: 0.5,
    color: `${theme.palette.secondary.main} !important`,
  },
  disableOther: {
    backgroundColor: theme.applyOpacityToHex(theme.palette.secondary.light, .5),
    color: `${theme.applyOpacityToHex(theme.palette.secondary.light, 1)} !important`,
    boxShadow: 'none ',
  },
  labelSpace: {
    margin: '0 8px',
    height: 22,
  },
  textLabel: {
    margin: '0 8px',
    height: 22,
    fontWeight: 500,
  },
  icon: {
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.greyScale[7],
    color: theme.palette.secondary.main,
    borderRadius: 18,
    border: `1px solid ${theme.palette.secondary.main}`,
    width: 36,
    minWidth: 36,
    height: 36,
    minHeight: 36,
  },

  containedIcon: {
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.greyScale[7],
    borderRadius: '50%',
    width: 32,
    minWidth: 32,
    height: 32,
    minHeight: 32,
  },

  mini: {
    height: 28,
    minWidth: 54,
  },
  miniLabel: {
    height: 16,
    lineHeight: '16px',
  },
});

export const QButtonVariantEnum = Object.freeze({
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  ICON: 'icon',
  CONTAINED_ICON: 'containedIcon',
});

class QButton extends PureComponent {
  render() {
    const { variant, classes, children, width, style, mini, ...props } = this.props;
    let styler = classes.textButton;
    let disabler = classes.disableOther;
    switch (variant) {
      case QButtonVariantEnum.CONTAINED: {
        styler = classes.conButton;
        disabler = classes.disableOther;
        break;
      }
      case QButtonVariantEnum.OUTLINED: {
        styler = classes.outButton;
        disabler = classes.disableOut;
        break;
      }
      case QButtonVariantEnum.ICON: {
        styler = classes.icon;
        disabler = classes.disableOut;
        break;
      }
      case QButtonVariantEnum.CONTAINED_ICON: {
        styler = classes.containedIcon;
        disabler = classes.disableOut;
        break;
      }
      default: {
        break;
      }
    }
    return (
      <Button
        color="primary"
        classes={{
          disabled: disabler,
          root: classNames(classes.root, styler, mini && classes.mini),
          label: classNames(variant === 'text' ? classes.textLabel : classes.labelSpace, mini && classes.miniLabel),
        }}
        style={{ width, ...style }}
        {...props}
      >
        {children}
      </Button>
    );
  }
}

QButton.defaultProps = {
  variant: "text",
  mini: false,
};

QButton.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.number,
  style: PropTypes.object,
  mini: PropTypes.bool,
};

export default compose(
  withStyles(styles)
)(QButton);
